module.exports = __webpack_public_path__ + "img/email.de935b8f.svg";